<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <mat-label>Select Input</mat-label>
        <mat-select [(ngModel)]="input_type" class="main-border-class">
          <mat-option value="date">Date</mat-option>
          <mat-option value="bill_number">Bill Number</mat-option>
        </mat-select>
      </div>
      <div class="col-3" *ngIf="input_type == 'date' ">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3" *ngIf="input_type == 'date' ">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" />
      </div>
      <div class="col-3" *ngIf="input_type == 'bill_number'">
        <mat-label>Bill Number</mat-label>
        <input type="text" [(ngModel)]="bill_number" class="main-border-class" />
      </div>

      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="getdisableCheck()">Get</button>
      </div>
  </div>
  </div>

</section>
